import isMobile from './is-mobile.js';

//グローバルナビ メガメニュー
$('.js-language-select').on({
  'touchstart mouseenter': function touchstartMouseenter() {
    if(!isMobile(1194)){
      $(this).addClass('is-language-select--show');
      // $("body").addClass('is-megaMenu--showPage');
      // $(this).next().find(".megamenu-content").css({"z-index": 500});
      // $(this).prev().find(".megamenu-content").css({"z-index": 500});
    }
  },
  'touchend mouseleave': function touchendMouseleave() {
    if(!isMobile(1194)){
      $(this).removeClass('is-language-select--show');
      // $("body").removeClass('is-megaMenu--showPage');
      // $(this).next().find(".megamenu-content").attr({"style": ""});
      // $(this).prev().find(".megamenu-content").attr({"style": ""});
    }
  }
});

// console.log(lang);

$('.js-language-select').on('click', function(e){
  if(isMobile(1194)){
    $(this).toggleClass('is-language-select--show');
    // if($(e.target).closest("a").is(".megamenu-main-link")) {
    //   $(this).toggleClass('is-language-select--show');
    // }
    return ! $(e.target).is(".l-header-subNavi-list__itemInner")
  }
})

var $lang = $("html").attr("lang");
var rep = "";
var $langRep = function(v) {
  if(v == "zh-cmn-Hans") {
    $lang = "ch"
  }
  if(v == "zh-cmn-Hant") {
    $lang = "zh"
  }
  return $lang;
}
var $langBase = $(".js-language-select .l-header-subNavi-list__itemInner").text();
$(".l-header-language-select-item").each(function(i, v) {
  var $href = $(this).find("a").attr("id");
  if($href.match($langRep($lang)) || $href == "/") {
    var $langText = $(this).find(".l-header-language-select-item__text").text();
    $(this).addClass("is-current");
    const limit = localStorage.getItem("languageLimit") || 0;
    const current = new Date().getTime();

    if(Number(limit) < current) {
      // $(".js-language-select .l-header-subNavi-list__itemInner").text($langBase + ":" + $langText);
      $(".js-language-select .l-header-subNavi-list__itemInner").text($langBase);
    }
    else {
      $(".js-language-select .l-header-subNavi-list__itemInner").text($langText);

    }
    // console.log($(this).find("a").attr("href"));
  }
})

